'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var MODIFIED_ELEMENTS_MARK_SEEN = exports.MODIFIED_ELEMENTS_MARK_SEEN = 'MODIFIED_ELEMENTS_MARK_SEEN';
var MODIFIED_ELEMENTS_FORCE_POLL = exports.MODIFIED_ELEMENTS_FORCE_POLL = 'MODIFIED_ELEMENTS_FORCE_POLL';

var MODIFIED_ELEMENTS_MAX = exports.MODIFIED_ELEMENTS_MAX = 10;

var MODIFIED_ELEMENTS_BOARD_MESSAGES = exports.MODIFIED_ELEMENTS_BOARD_MESSAGES = {
    INVITED: 'INVITED',
    UPDATED: 'UPDATED'
};

var MODIFIED_ELEMENTS_MESSAGES = exports.MODIFIED_ELEMENTS_MESSAGES = {
    CREATED: 'CREATED',
    UPDATED: 'UPDATED'
};

var INBOX_MOVE_MEANINGFUL_DIST = exports.INBOX_MOVE_MEANINGFUL_DIST = 3;
var CANVAS_MOVE_MEANINGFUL_DIST_SQRD = exports.CANVAS_MOVE_MEANINGFUL_DIST_SQRD = Math.pow(34, 2);
var UPDATE_MEANINGFUL_CHANGE_KEY_LIST = exports.UPDATE_MEANINGFUL_CHANGE_KEY_LIST = ['textContent', 'caption', 'showCaption', 'image', 'link'];

var MILANOTE_EMAILS = exports.MILANOTE_EMAILS = {
    SUPPORT: 'support@milanote.com',
    INFO: 'info@milanote.com'
};

var URL_ENCODINGS = exports.URL_ENCODINGS = {
    NEW_LINE: '%0A',
    TAB: '%09'
};


//////////////////
// WEBPACK FOOTER
// ./src/common/notifications/notificationConstants.js
// module id = 88
// module chunks = 0